// CP → département français.
// Miroir exact de server/src/utils/departement.ts.

export function departementFromCP(cp: string | null | undefined): string | null {
  if (cp === null || cp === undefined) return null;
  const c = cp.trim();
  if (!/^\d{5}$/.test(c)) return null;
  if (c.startsWith('20')) {
    const n = Number.parseInt(c, 10);
    return n >= 20000 && n <= 20190 ? '2A' : '2B';
  }
  if (c.startsWith('97') || c.startsWith('98')) {
    return c.slice(0, 3);
  }
  return c.slice(0, 2);
}
